import type BABYLON from 'babylonjs';

export function setCursor(scene: BABYLON.Scene, cursor: string): void {
  const canvas = scene.getEngine().getRenderingCanvas();
  if (canvas) {
    canvas.style.cursor = cursor;
  }
  // eslint-disable-next-line no-param-reassign
  scene.defaultCursor = cursor;
}
